export default "__VITE_ASSET__41f5c74a__"